import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25438bc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }

import { contentTableConfig } from './config/content.config'
import { createData, editPageData } from '@/service/main/system'
import PageContent from '@/components/PageContent.vue'
import { ref, reactive } from "vue";
import { el } from '@fullcalendar/core/internal-common';


export default /*#__PURE__*/_defineComponent({
  __name: 'SensitiveWordManage',
  setup(__props) {

const pageContentRef = ref<InstanceType<typeof PageContent>>()

const dialogVisible = ref(false)
const dialogtitle = ref('')

const categoryList= [
  {value:1,label:'客户逼单期敏感词'},
  {value:2,label:'业务员逼单期敏感词'}
]
const dialogClose = () => {
  dialogVisible.value = false
  Object.keys(form).forEach(key => {
     (form as any)[key] = '';
  });
  currid.value = ''
}

let currid = ref('')

let form = reactive({
  category: '',
  content: '',
  description:''
})
const handleNewBtn = () => {
  console.log('点击新增')
  dialogtitle.value = '新增'
  dialogVisible.value = true
}
const handleEditBtn = (item: any) => {
  console.log('点击编辑')
  form.category = item.category
  form.content = item.content
  form.description = item.description
  currid.value = item.id
  dialogtitle.value = '编辑'
  dialogVisible.value = true
}
const doSave = async () => {
  if (currid.value) {
    //新增
    console.log('编辑')
    await editPageData('/main/sensitiveWords/update/' + currid.value, form).then((res) => {
      dialogClose()
      pageContentRef.value?.getPageData()
    })
  } else {

    console.log('新增')
    await createData('/main/sensitiveWords/add', form).then((res) => {
      dialogClose()

      pageContentRef.value?.getPageData()
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PageContent, {
      class: "card-box",
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "sensitiveWords",
      delUrl: "/main/sensitiveWords/delete",
      onNewBtnClick: handleNewBtn,
      onEditBtnClick: handleEditBtn
    }, {
      category: _withCtx((scope) => [
        _createTextVNode(_toDisplayString(categoryList.find(item => item.value === scope.row.category)?.label || scope.row.category), 1)
      ]),
      _: 1
    }, 8, ["contentTableConfig"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogtitle.value,
      width: "30%",
      onClose: dialogClose
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: doSave
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 保存 ")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          _createVNode(_component_el_form, {
            model: _unref(form),
            "label-width": "80px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, { label: "类别" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(form).category,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).category) = $event)),
                    placeholder: "请选择类别",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(categoryList, (item) => {
                        return _createVNode(_component_el_option, {
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "敏感词" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(form).content,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).content) = $event)),
                    placeholder: "请输入敏感词"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, { label: "描述" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(form).description,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).description) = $event)),
                    placeholder: "请输入描述"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}
}

})